<div class="flex flex-col justify-start sidenav-body" *ngIf="!loading">
  <div class="table-container" *ngIf="sites?.length">
    <tree-display
      [treeData]="treeData"
      [showSearch]="false"
      [showControls]="false"
      [selectedNodes]="selectedNodes"
      [typeIdentifier]="disabledNodeAttribute"
      [labelIdentifier]="labelIdentifier"
      [iconDefinitions]="iconMap"
      [iconIdentifier]="iconIdentifier"
      [disabledNodeDefinitions]="disabledNodeDefinitions"
      (selection$)="selectionHandler($event)"
    ></tree-display>
  </div>
  <div class="list-empty" *ngIf="!loading && !sites?.length">
    {{ 'sidenav.list.none_configured' | translate }}
  </div>
</div>
<div class="spinner-container" *ngIf="loading">
  <mat-spinner mode="indeterminate" diameter="60"></mat-spinner>
</div>
